import { IDetailsListStyles, IMessageBarStyles } from '@fluentui/react';
import { FontSizes, FontWeights, IH2OTheme, Sizes } from '@h2oai/ui-kit';

export const fwManagementTopStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
};

export const fwTableOptionStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
};

export const fwTypeAreaStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  marginTop: '2rem',
};

export const tableWrapper: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '2rem',
};

export const sidePanelStyle: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  right: 0,
};

export const sidePanelFooterStyle = {
  marginTop: '20px',
  display: 'flex',
  justifyContent: 'flex-end',
};

export const titleAreaStyle: React.CSSProperties = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
};

export const anchorStyles = (theme: IH2OTheme): React.CSSProperties => ({
  color: theme.palette?.gray600,
  fontWeight: FontWeights.semiBold,
  fontSize: FontSizes.button,
  textDecoration: 'none',
});

export const actionAreaStyle: React.CSSProperties = {
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '1rem',
  margin: '1rem 0',
};

export const tableAreaStyle = {};

export const titleStyle = {
  margin: '0px',
};

export const tableStyle = {};

export const saveChangeButtonStyle = {
  marginLeft: '1rem',
};

export const pageTopButtonStyle: React.CSSProperties = {
  display: 'flex',
  position: 'relative',
  paddingBottom: Sizes.buttonPaddingTopBottom,
};

export const alertButtonStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  paddingBottom: Sizes.buttonPaddingTopBottom,
  paddingTop: Sizes.buttonPaddingTopBottom,
};

export const TableBackgroundStyle = (theme: IH2OTheme) => ({
  backgroundColor: theme.palette?.gray200,
  overflowY: 'auto' as const,
});

export const firewallInfoMessageStyles: Partial<IMessageBarStyles> = {
  root: {
    width: '100%',
    marginTop: '16px',
  },
};

export const firewallManagementTableStyles = (theme: IH2OTheme): Partial<IDetailsListStyles> => ({
  root: {
    height: '100%',
    selectors: {
      '.ms-DetailsHeader': {
        padding: Sizes.padding,
        paddingRight: 0,
        paddingLeft: 0,
        background: theme.palette?.white,
      },
      '.ms-DetailsHeader-cell': {
        borderRight: `1px solid ${theme.palette?.gray300}`,
        color: theme.palette?.gray700,
      },
      '.ms-DetailsRow-cell': {
        display: 'flex',
        alignItems: 'center',
        fontSize: FontSizes.xsmall,
        color: theme.palette?.gray600,
        padding: 0,
      },
      '.ms-DetailsRow': {
        backgroundColor: theme.palette?.gray200,
      },
      '.ms-DetailsRow:hover': {
        backgroundColor: theme.palette?.yellow100,
      },
      '.ms-DetailsRow.is-selected': {
        backgroundColor: theme.palette?.primary200,
      },
      '.ms-Check.is-checked': {
        selectors: {
          '::before': {
            backgroundColor: theme.palette?.primary600,
          },
          '.ms-Check-circle': {
            color: theme.palette?.primary600,
          },
          '.ms-Check-check': {
            color: `${theme.palette?.white} !important`,
          },
        },
      },
      '.ms-Check:hover .ms-Check-circle': {
        borderColor: `${theme.palette?.primary600} !important`,
      },
      '.ms-DetailsList-contentWrapper': {
        overflowY: 'auto',
        maxHeight: 'calc(100vh - 430px)',
      },
    },
  },
});
